import { EntityCommonInfoModel, FilteredPagedQueryResult, FilteredPagedModel, CommonMultiDeleteModel } from "../../entities/common";
import { apiSlice, TagTypes } from "./apiSlice";
import { getQuerySearchParams } from "../../utils";
import { DpsModel } from "../../entities/dps";

export const dpsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDpsCommonInfo: builder.query<EntityCommonInfoModel, undefined>({
      query: () => `/dps/commonInfo`,
      providesTags: [{ type: TagTypes.Dps, id: "LIST" }],
    }),
    getDpsFilteredPaged: builder.query<FilteredPagedQueryResult<DpsModel>, FilteredPagedModel>({
      query: ({ page = 1, pageSize = 10, searchTerm = "", sortFieldName = "", descending = false, ...rest }: FilteredPagedModel) => {
        let url = `/dps/pageable?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortFieldName=${sortFieldName}&descending=${descending}`;
        const restParams = getQuerySearchParams(rest);
        if (restParams) {
          url += `&${restParams}`;
        }

        return url;
      },
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: TagTypes.Dps, id: "PARTIAL-LIST" },
              ...result.data.map(({ id }: { id: number | string }) => ({
                type: TagTypes.Dps,
                id,
              })),
            ]
          : [{ type: TagTypes.Dps, id: "PARTIAL-LIST" }],
    }),
    getDps: builder.query<DpsModel, number>({
      query: (costId) => `/dps/getById/${costId}`,
      providesTags: (result, error, arg) => [{ type: TagTypes.Dps, id: arg }],
    }),
    scrapDps: builder.query<DpsModel, { tracingNumber: string }>({
      query: ({ tracingNumber }) => ({
        url: "/dps/scrap",
        method: "POST",
        body: { tracingNumber },
      }),
      providesTags: [{ type: TagTypes.Dps, id: "Scrap" }],
    }),
    addDps: builder.mutation({
      query: (initialDps) => ({
        url: "/dps",
        method: "POST",
        body: initialDps,
      }),
      invalidatesTags: [
        { type: TagTypes.Dps, id: "LIST" },
        { type: TagTypes.Dps, id: "PARTIAL-LIST" },
      ],
    }),
    editDps: builder.mutation({
      query: (cost) => ({
        url: `/dps/${cost.id}`,
        method: "PUT",
        body: cost,
      }),
      invalidatesTags: (result, error, arg) => [{ type: TagTypes.Dps, id: arg.id }],
    }),
    deleteDps: builder.mutation({
      query: (costId) => ({
        url: `/dps/${costId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              { type: TagTypes.Dps, id: arg },
              { type: TagTypes.Dps, id: "LIST" },
            ],
    }),
    deleteMultiDpses: builder.mutation({
      query: (multiDeleteModel: CommonMultiDeleteModel) => ({
        url: "/dps/multiDelete",
        method: "DELETE",
        body: multiDeleteModel,
      }),
      invalidatesTags: (result, error, arg) =>
        error
          ? []
          : [
              ...arg.ids.map((id: number) => ({
                type: TagTypes.Dps,
                id,
              })),
              { type: TagTypes.Dps, id: "LIST" },
            ],
    }),
  }),
});

export const {
  useGetDpsCommonInfoQuery,
  useGetDpsFilteredPagedQuery,
  useGetDpsQuery,
  useAddDpsMutation,
  useEditDpsMutation,
  useScrapDpsQuery,
  useLazyScrapDpsQuery,
  useDeleteDpsMutation,
  useDeleteMultiDpsesMutation,
} = dpsApi;
